import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { merchantActionTypes } from '../action-types';
import * as React from 'react';
import { IAction } from '../merchant-interfaces';
import { PreferencesReturnTypes } from '../../../constants/profile-settings/preferences-form';

export const setPreferences = async (params: PreferencesReturnTypes, merchantId: string): Promise<void> => {
	await axios.put(`${BASE_URL.MERCHANTS}/merchant/${merchantId}/preferences`, params);
};

export const setPlatformSystem = (dispatch: React.Dispatch<IAction>, value: string): void => {
	let platform = '';
	if (value.includes('mac')) {
		platform = 'mac';
	} else if (value.includes('win')) {
		platform = 'windows';
	}
	dispatch({ type: merchantActionTypes.SET_PLATFORM_SYSTEM, payload: platform });

};
